import { OsUpdate } from '@era/osupdates-sdk';
import { Selector, createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAvailableOsUpdates from './available-os-updates.reducer';
import { AvailableOsUpdatesState } from './available-os-updates.state';

export const selectAvailableOsUpdatesState = createFeatureSelector<AvailableOsUpdatesState>('available-osupdates');

export const selectAllAvailableOsUpdates = createSelector(
  selectAvailableOsUpdatesState,
  fromAvailableOsUpdates.selectAllAvailableOsUpdates
);

export const selectAvailableOsUpdatesLoaded: Selector<object, boolean> = createSelector(
  selectAllAvailableOsUpdates,
  (updates: OsUpdate[]) => updates && updates.length > 0
);
